import React from "react";
import PartHistogramPanel from "./PartHistogramPanel";
import SectionLoader from "../general/component/loading";

export default function SectionHistogram({
                                             jwtToken,
                                             histogramForm,
                                             histogramFormName,
                                             histogramVarOptions,
                                             disableHistogramFields,
                                             onFormChange,
                                             onFormSubmit,
                                             histograms,
                                             handleUpdate,
                                             showAlert,
                                             loading
}) {
    return (
        <section style={{ marginBottom: "40px" }}>
            <h2 style={{marginTop: "40px"}}>Histogram</h2>
            <hr style={{marginTop:"0px"}}/>
            {/* form for creating new histogram */}
            <div className="form-group" style={{width: "800px", marginBottom: "20px"}}>
                <form id="createHistogram" onSubmit={onFormSubmit}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Variable</th>
                                <th>Step Size</th>
                                <th>Bar Count</th>
                                <th>Min</th>
                                <th colSpan="2">Max</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input style={{width: "200px"}}
                                           className="form-control"
                                           type="text"
                                           name="name"
                                           placeholder="histogram name..."
                                           value={histogramFormName}
                                           onChange={onFormChange}/>
                                </td>
                                <td>
                                    <select style={{width: "220px"}}
                                            value={histogramForm.variable}
                                            onChange={onFormChange}
                                            className="form-control"
                                            name="variable">
                                        <option value="">---Select variable---</option>
                                        {histogramVarOptions}
                                    </select>
                                </td>
                                <td>
                                    <input style={{width: "80px"}}
                                           className="form-control"
                                           type="number"
                                           name="step"
                                           value={histogramForm.step ?? ""}
                                           onChange={onFormChange}
                                           disabled={disableHistogramFields}/>
                                </td>
                                <td>
                                    <input style={{width: "80px"}}
                                           className="form-control"
                                           type="number"
                                           name="bars"
                                           value={histogramForm.bars ?? ""}
                                           onChange={onFormChange}
                                           disabled={disableHistogramFields}/>
                                </td>
                                <td>
                                    <input style={{width: "80px"}}
                                           className="form-control"
                                           type="number"
                                           name="min"
                                           value={histogramForm.min ?? ""}
                                           onChange={onFormChange}
                                           disabled={disableHistogramFields}/>
                                </td>
                                <td>
                                    <input style={{width: "80px"}}
                                           className="form-control"
                                           type="number"
                                           name="max"
                                           value={histogramForm.max ?? ""}
                                           onChange={onFormChange}
                                           disabled={disableHistogramFields}/>
                                </td>
                                <td>
                                    <button type="submit"
                                            style={{marginTop:"2px", paddingLeft:"30px", paddingRight:"30px"}}
                                            className="btn btn-primary"
                                            title="Create histogram with applied parameters">CREATE</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
            {/* render all histograms */}
            {loading ? (
                <SectionLoader />
            ) : histograms && histograms.length > 0 ? (
                histograms.map((histogram, index) => (
                    <PartHistogramPanel
                        key={histogram.id}
                        jwtToken={jwtToken}
                        histogramIndex={index}
                        histogramData={histogram}
                        handleUpdate={handleUpdate}
                        showAlert={showAlert}
                    />
                ))
            ) : (
                <div className="alert alert-warning" style={{ textAlign: "center" }}>
                    <strong>No Histograms created.</strong>
                </div>
            )}
        </section>
    );
}
